import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import CardComponent from './CardComponent';
import SurrenderConfirmModal from './SurrenderConfirmModal';
import ProposeDrawConfirmModal from './ProposeDrawConfirmModal';
import DeclineBattleConfirmModal from './DeclineBattleConfirmModal';
import { getCardBackImage } from '../../common';
export default class CardSlider extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "elementalsEl", null);
    _defineProperty(this, "bonusEl", null);
    // No visible controls: on desktop the card row can be grabbed and dragged
    // with the mouse; touch devices keep native finger-scroll untouched (drag
    // only activates for pointerType === 'mouse').
    _defineProperty(this, "rowDrag", null);
    _defineProperty(this, "onRowScroll", () => m.redraw());
    _defineProperty(this, "onResize", () => m.redraw());
    /** Start of mouse drag-scroll. Touch/pen are left alone since their native
     * swipe scrolling works better than any custom implementation. */
    _defineProperty(this, "onRowPointerDown", (e, key) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const el = this.rowEl(key);
      if (!el) return;
      this.rowDrag = {
        key,
        pointerId: e.pointerId,
        startX: e.clientX,
        startScrollLeft: el.scrollLeft,
        moved: false
      };
      window.addEventListener('pointermove', this.onRowPointerMove);
      window.addEventListener('pointerup', this.onRowPointerUp);
      window.addEventListener('pointercancel', this.onRowPointerUp);
    });
    _defineProperty(this, "onRowPointerMove", e => {
      const drag = this.rowDrag;
      if (!drag || e.pointerId !== drag.pointerId) return;
      const el = this.rowEl(drag.key);
      if (!el) return;
      const deltaX = e.clientX - drag.startX;
      if (!drag.moved && Math.abs(deltaX) > 4) {
        drag.moved = true;
        el.classList.add('is-dragging');
      }
      if (drag.moved) {
        el.scrollLeft = drag.startScrollLeft - deltaX;
      }
    });
    _defineProperty(this, "onRowPointerUp", () => {
      const drag = this.rowDrag;
      if (!drag) return;
      const el = this.rowEl(drag.key);
      el == null || el.classList.remove('is-dragging');
      // If the drag actually moved the row, suppress the synthetic "click" the
      // browser fires after pointerup — otherwise the drag would accidentally
      // select whichever card the cursor landed on.
      if (drag.moved && el) el.dataset.suppressClick = '1';
      this.rowDrag = null;
      window.removeEventListener('pointermove', this.onRowPointerMove);
      window.removeEventListener('pointerup', this.onRowPointerUp);
      window.removeEventListener('pointercancel', this.onRowPointerUp);
    });
    /** Capture-phase click interceptor on the row — suppresses the "ghost"
     * click on a card right after a mouse drag (see onRowPointerUp). */
    _defineProperty(this, "onRowClickCapture", e => {
      const el = e.currentTarget;
      if (el.dataset.suppressClick === '1') {
        delete el.dataset.suppressClick;
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    window.addEventListener('resize', this.onResize);
  }
  onremove(vnode) {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('pointermove', this.onRowPointerMove);
    window.removeEventListener('pointerup', this.onRowPointerUp);
    window.removeEventListener('pointercancel', this.onRowPointerUp);
    super.onremove(vnode);
  }
  rowEl(key) {
    return key === 'elementals' ? this.elementalsEl : this.bonusEl;
  }
  view() {
    var _app$session$user;
    const _this$attrs = this.attrs,
      cards = _this$attrs.cards,
      playedCardIds = _this$attrs.playedCardIds,
      mana = _this$attrs.mana,
      battle = _this$attrs.battle,
      selectedElementalId = _this$attrs.selectedElementalId,
      selectedBonusId = _this$attrs.selectedBonusId,
      onSelectElemental = _this$attrs.onSelectElemental,
      onSelectBonus = _this$attrs.onSelectBonus,
      onSurrendered = _this$attrs.onSurrendered,
      onDrawProposed = _this$attrs.onDrawProposed,
      onDeclined = _this$attrs.onDeclined,
      onSubmitTurn = _this$attrs.onSubmitTurn,
      canSubmit = _this$attrs.canSubmit;
    const allowDraw = !!app.forum.attribute('arenaAllowDraw');
    // Only reachable during the actor's own first move: neither side has
    // committed a card yet on their behalf (see DeclineBattleController's
    // matching backend check).
    const canDecline = battle.currentTurn() === 1;
    const available = cards.filter(c => !playedCardIds.includes(parseInt(c.id())));
    const elementals = available.filter(c => {
      var _c$isElemental, _c$isElemental2, _c$cardType;
      return (_c$isElemental = (_c$isElemental2 = c.isElemental) == null ? void 0 : _c$isElemental2.call(c)) != null ? _c$isElemental : ((_c$cardType = c.cardType) == null ? void 0 : _c$cardType.call(c)) !== 'bonus';
    });
    const bonusCards = available.filter(c => {
      var _c$isBonus, _c$isBonus2, _c$cardType2;
      return (_c$isBonus = (_c$isBonus2 = c.isBonus) == null ? void 0 : _c$isBonus2.call(c)) != null ? _c$isBonus : ((_c$cardType2 = c.cardType) == null ? void 0 : _c$cardType2.call(c)) === 'bonus';
    });
    const elementalSelected = selectedElementalId !== null;
    const bonusSelected = selectedBonusId !== null;

    // This is always the player's own hand, so the card back comes from their own preference.
    const cardBackImage = getCardBackImage((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.attribute('arenaCardBack'));
    return m("div", {
      className: "ArenaCardSlider"
    }, m("div", {
      className: "ArenaCardSlider-header"
    }, m("div", {
      className: "ArenaCardSlider-headerRight"
    }, canDecline && m(Button, {
      className: "Button ArenaCardSlider-decline",
      icon: "fas fa-door-closed",
      onclick: () => app.modal.show(DeclineBattleConfirmModal, {
        battle,
        onDeclined
      })
    }, app.translator.trans('forumaker-arena.forum.decline_battle.btn')), m(Button, {
      className: "Button ArenaCardSlider-surrender",
      icon: "fas fa-flag",
      onclick: () => app.modal.show(SurrenderConfirmModal, {
        battle,
        onSurrendered
      })
    }, app.translator.trans('forumaker-arena.forum.surrender.btn')), allowDraw && m(Button, {
      className: "Button ArenaCardSlider-proposeDraw",
      icon: "fas fa-handshake",
      onclick: () => app.modal.show(ProposeDrawConfirmModal, {
        battle,
        onProposed: onDrawProposed
      })
    }, app.translator.trans('forumaker-arena.forum.propose_draw.btn')), onSubmitTurn &&
    // Plain button (like Surrender/Propose Draw) until the turn is
    // ready, then switches to the green Button--primary style.
    m(Button, {
      className: "Button ".concat(canSubmit ? 'Button--primary' : '', " ArenaCardSlider-submitBtn"),
      icon: "fas fa-paper-plane",
      disabled: !canSubmit || this.submitting,
      loading: this.submitting,
      onclick: () => {
        if (!canSubmit || this.submitting) return;
        this.submitting = true;
        m.redraw();
        onSubmitTurn().finally(() => {
          this.submitting = false;
          m.redraw();
        });
      }
    }, app.translator.trans('forumaker-arena.forum.card_slider.submit_turn')))), m("div", {
      className: "ArenaCardSlider-body"
    }, m("div", {
      className: "ArenaCardSlider-section"
    }, m("div", {
      className: "ArenaCardSlider-sectionLabel"
    }, m("i", {
      className: "fas fa-cards"
    }), m("span", null, app.translator.trans('forumaker-arena.forum.card_slider.main_card')), elementalSelected && m("span", {
      className: "ArenaCardSlider-badge ArenaCardSlider-badge--ok"
    }, m("i", {
      className: "fas fa-check"
    }))), m("div", {
      className: "ArenaCardSlider-cards",
      oncreate: vnode => {
        this.elementalsEl = vnode.dom;
        this.elementalsEl.addEventListener('scroll', this.onRowScroll, {
          passive: true
        });
        this.elementalsEl.addEventListener('click', this.onRowClickCapture, true);
      },
      onpointerdown: e => this.onRowPointerDown(e, 'elementals')
    }, elementals.length === 0 ? m("div", {
      className: "ArenaCardSlider-empty"
    }, app.translator.trans('forumaker-arena.forum.card_slider.no_cards')) : elementals.map(card => {
      const isSelected = selectedElementalId === parseInt(card.id());
      const isDisabled = card.cost() > mana || elementalSelected && !isSelected;
      return m(CardComponent, {
        key: card.id(),
        card: card,
        compact: true,
        selected: isSelected,
        disabled: isDisabled,
        cardBackImage: cardBackImage,
        onclick: !isDisabled ? onSelectElemental : undefined
      });
    }))), bonusCards.length > 0 && m("div", {
      className: "ArenaCardSlider-section ArenaCardSlider-section--bonus"
    }, m("div", {
      className: "ArenaCardSlider-sectionLabel"
    }, m("i", {
      className: "fas fa-star"
    }), m("span", null, app.translator.trans('forumaker-arena.forum.card_slider.bonus_card')), bonusSelected && m("span", {
      className: "ArenaCardSlider-badge ArenaCardSlider-badge--ok"
    }, m("i", {
      className: "fas fa-check"
    }))), m("div", {
      className: "ArenaCardSlider-cards",
      oncreate: vnode => {
        this.bonusEl = vnode.dom;
        this.bonusEl.addEventListener('scroll', this.onRowScroll, {
          passive: true
        });
        this.bonusEl.addEventListener('click', this.onRowClickCapture, true);
      },
      onpointerdown: e => this.onRowPointerDown(e, 'bonus')
    }, bonusCards.map(card => {
      var _elementals$find$cost, _elementals$find;
      const isSelected = selectedBonusId === parseInt(card.id());
      const elementalCost = elementalSelected ? (_elementals$find$cost = (_elementals$find = elementals.find(c => parseInt(c.id()) === selectedElementalId)) == null ? void 0 : _elementals$find.cost()) != null ? _elementals$find$cost : 0 : 0;
      const isDisabled = card.cost() + elementalCost > mana || bonusSelected && !isSelected;
      return m(CardComponent, {
        key: card.id(),
        card: card,
        compact: true,
        selected: isSelected,
        disabled: isDisabled,
        cardBackImage: cardBackImage,
        onclick: !isDisabled ? onSelectBonus : undefined
      });
    })))), (elementalSelected || bonusSelected) && !canSubmit && m("div", {
      className: "ArenaCardSlider-footer ArenaCardSlider-footer--warn"
    }, m("i", {
      className: "fas fa-exclamation-triangle"
    }), m("span", null, elementalSelected ? app.translator.trans('forumaker-arena.forum.card_slider.need_bonus') : app.translator.trans('forumaker-arena.forum.card_slider.need_elemental'))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/CardSlider', CardSlider);